// Utilitaires pour les liens contextuels entre les FAQs et les fiches comptes.
import { FAQ } from "@/data/faq";

// Extrait toutes les références de comptes mentionnées dans une FAQ
// (recherche des numéros entre backticks dans cols, rows.cells, exemple)
export function getFaqAccountRefs(faq) {
  const acc = new Set();
  const scan = (s) => {
    if (typeof s !== "string") return;
    const matches = s.match(/`(\d{2,6})`/g);
    if (matches) {
      matches.forEach((m) => {
        const num = m.replace(/`/g, "");
        if (num.length >= 2 && num.length <= 6) acc.add(num);
      });
    }
  };
  faq.cols?.forEach((c) => scan(c.label));
  faq.rows?.forEach((r) => {
    scan(r.critere);
    r.cells?.forEach(scan);
  });
  scan(faq.exemple);
  scan(faq.memo);
  return acc;
}

// Pour un numéro de compte donné, retourne la liste des FAQs concernées
export function getFaqsForAccount(num) {
  if (!num) return [];
  return FAQ.filter((f) => getFaqAccountRefs(f).has(String(num)));
}
